<script lang="ts">
  import { getContext } from 'svelte';
  import { ListCard } from './components/list';
  import { getWrapperStyles } from './helpers/sections-helper';
  import { SplideSlide } from '@splidejs/svelte-splide';
  import { Carousel, Heading, Wrapper } from './components';
  import { ShowMoreArrow } from './components/icons';
  import { SERVICES_CAROUSEL_OPTIONS } from './components/constants/carousel';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;
  // todo: where is this page coming from?
  export let page = '';

  const isEditable = getContext<boolean>('isEditable') || false;

  $: ({ borderRadius } = settings);

  const showMore = () => {
    currentItems = properties.items.length;
  };

  const hideItems = () => {
    currentItems = 3;
  };

  $: currentItems = isEditable ? properties?.items.length : 3;
  $: isShowLess =
    properties.items.length === currentItems && currentItems > 3 && !isEditable;
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  {#if properties?.items.length}
    <div
      class="list-container {properties.cardStyle}"
      style="color:var(--vlt-lp-text)"
      id={properties.anchor}
    >
      <div class="list-content" style={getWrapperStyles()}>
        {#if properties.heading}
          <Heading type={'h2'} css={'text-align:center;margin-bottom:50px;'}
            >{@html properties.heading}</Heading
          >
        {/if}

        {#if !properties.scroller && properties.items.length > 3}
          <Carousel options={SERVICES_CAROUSEL_OPTIONS(+page)}>
            {#each properties.items as list}
              <SplideSlide>
                <ListCard
                  {properties}
                  {borderRadius}
                  image={list.image}
                  heading={list.heading}
                  text={list.text}
                  button={list.button}
                  isSlide={properties.scroller}
                  imageSize={properties.imageSize}
                  alignment={properties.alignment}
                  cardStyle={properties.cardStyle}
                />
              </SplideSlide>
            {/each}
          </Carousel>
        {:else}
          <div
            class="grid-container {properties.items.length < 3
              ? 'centered'
              : ''}"
          >
            {#each properties.items.slice(0, currentItems) as list}
              <ListCard
                {properties}
                {borderRadius}
                length={properties.items.length}
                image={list.image}
                heading={list.heading}
                text={list.text}
                price={list.price}
                button={list.button}
                imageSize={properties.imageSize}
                alignment={properties.alignment}
                cardStyle={properties.cardStyle}
              />
            {/each}
          </div>
          {#if currentItems < properties.items.length}
            <button class="more" on:click={showMore}>
              <ShowMoreArrow />
              <span>show more</span>
              <ShowMoreArrow />
            </button>
          {:else if isShowLess}
            <button class="more" on:click={hideItems}>
              <ShowMoreArrow isReverse />
              <span>show less</span>
              <ShowMoreArrow isReverse />
            </button>
          {/if}
        {/if}
      </div>
    </div>
  {/if}
</Wrapper>

<style>
  .more {
    max-width: 200px;
    width: 100%;
    height: 48px;
    background: transparent;
    cursor: pointer;
    border: 1px solid #5373f0;
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #5373f0;
    text-transform: capitalize;
    margin-top: 30px;
  }
  .list-prev {
    left: -5vw !important;
  }
  .list-next {
    right: -3vw !important;
  }
  button {
    display: block;
    margin: 0 auto;
  }
  span {
    margin-right: 23px;
    margin-left: 23px;
  }
  .list-container {
    width: 100%;
  }
  .list-container.card {
    display: flex;
  }
  :global(.splide__list) {
    margin-bottom: 30px !important;
  }
  :global(.splide__track) {
    padding-right: 15px !important;
  }

  @media screen and (max-width: 960px) {
    .list-container {
      padding: 0;
    }
  }
  @media screen and (max-width: 767px) {
    .list-content {
      padding: 0 15px !important;
    }
  }

  .grid-container {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
  }
  .grid-container.centered {
    display: flex;
    flex-wrap: wrap;
  }
  @media screen and (max-width: 980px) {
    .grid-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media screen and (max-width: 720px) {
    .grid-container {
      display: grid;
      grid-template-columns: 1fr;
    }
  }
</style>
